import {ADMIN_ROOT_API_URL} from "../../../../config/settings.js"

export const SEARCH_USER = ADMIN_ROOT_API_URL + "/search_user";
export const DELETE_USER = ADMIN_ROOT_API_URL + "/delete_user";
export const GET_USER_ID = ADMIN_ROOT_API_URL + "/get_user_id";